<template>
  <v-card>
    <v-data-table
      :headers="headers"
      :items="sources"
      class="mt-1"
      hide-default-footer
      :loading="loading"
    >
      <template v-slot:item="props">
        <tr>
          <td>{{ props.item.id }}</td>
          <td>
            <span
              v-if="props.item.object === 'card' || props.item.type === 'card'"
              >Card</span
            >
            <span v-else>Sepa debit</span>
          </td>
          <td>
            <span v-if="props.item.object === 'card'">{{
              props.item.brand
            }}</span>
            <span v-else-if="props.item.type === 'card'">{{
              props.item.card.brand
            }}</span>
            <span v-else-if="props.item.type === 'sepa_debit'"
              >Bank account</span
            >
          </td>
          <td>
            <span v-if="props.item.object === 'card'"
              >{{ props.item.exp_month }} / {{ props.item.exp_year }}</span
            >
            <span v-else-if="props.item.type === 'card'"
              >{{ props.item.card.exp_month }} /
              {{ props.item.card.exp_year }}</span
            >
          </td>
          <td>
            <span v-if="props.item.object === 'card'"
              >*** {{ props.item.last4 }}</span
            >
            <span v-else-if="props.item.type === 'card'"
              >*** {{ props.item.card.last4 }}</span
            >
            <span v-else-if="props.item.type === 'sepa_debit'">
              {{ props.item.sepa_debit.country
              }}{{ props.item.sepa_debit.bank_code
              }}{{ props.item.sepa_debit.branch_code }} ***
              {{ props.item.sepa_debit.last4 }}
            </span>
          </td>
        </tr>
      </template>
      <template v-slot:no-data>No data</template>
    </v-data-table>
  </v-card>
</template>

<script>
import fb from "@/firebase";

export default {
  name: "ProfileSources",
  components: {},
  props: {
    uid: String
  },
  data: () => ({
    sources: [],
    loading: false,
    currentProfile: "",
    headers: [
      { text: "Source ID", value: "id", sortable: false },
      { text: "Type", value: "type", sortable: false },
      { text: "Brand", value: "description", sortable: false },
      { text: "Expiry date", value: "expiry date", sortable: false },
      { text: "Reference", value: "reference", sortable: false }
    ]
  }),
  methods: {},
  mounted: function() {
    this.currentProfile = this.uid;
  },
  watch: {
    currentProfile: function(val) {
      fb.db
        .collection("stripe_customers")
        .doc(`${val}`)
        .collection("sources")
        .get()
        .then(snapshot => {
          snapshot.forEach(doc => {
            let source = doc.data();
            source.id = doc.id;
            this.sources.push(source);
          });
        });
    }
  }
};
</script>
